// SPDX-FileCopyrightText: 2017-2022 City of Espoo
//
// SPDX-License-Identifier: LGPL-2.1-or-later

import React from 'react'

import {
  daycareAssistanceLevels,
  preschoolAssistanceLevels
} from 'lib-common/generated/api-types/assistance'
import type { EmployeeCustomizations } from 'lib-customizations/types'

import { employeeConfig } from './appConfigs'
import { H3, P } from 'lib-components/typography'
import MunicipalityLogo from './assets/municipality-logo-primary.svg'
import featureFlags from './featureFlags'

const customizations: EmployeeCustomizations = {
  appConfig: employeeConfig,
  translations: {
    fi: {
      common: {
        retroactiveConfirmation: {
          checkboxLabel:
            'Ymmärrän, olen asiasta yhteydessä laskutustiimiin varhaiskasvatus@sotkamo.fi *'
        }
      },
      footer: {
        cityLabel: 'Sotkamon kunta',
        linkLabel: 'Sotkamon varhaiskasvatus',
        linkHref: 'https://www.sotkamo.fi/varhaiskasvatus-ja-koulutus-2/varhaiskasvatus/'
      },
      unitEditor: {
        placeholder: {
          email: 'etunimi.sukunimi@sotkamo.fi',
          url: 'esim. https://www.sotkamo.fi/fi/toimipisteet/15585',
        }
      },
      welcomePage: {
        text: 'Olet kirjautunut sisään Sotkamon kunnan eVaka-palveluun. Käyttäjätunnuksellesi ei ole vielä annettu oikeuksia, jotka mahdollistavat palvelun käytön. Tarvittavat käyttöoikeudet saat omalta esimieheltäsi.'
      },
      preferredFirstName: {
        description:
      'Voit määritellä eVakassa käytössä olevan kutsumanimesi. Kutsumanimen tulee olla jokin etunimistäsi. Jos nimesi on vaihtunut ja sinulla on tarve päivittää eVakaan uusi nimesi, ole yhteydessä varhaiskasvatuksen hallintoon.',
      },
      login: {
        loginAD: 'Sotkamon AD',
      },
      incomeStatement: {
        noIncomeTitle:
          'Ei mitään tuloja tai tukia, tiedot saa tarkastaa Kelasta.',
        incomesRegister:
          'Hyväksyn, että tuloihini liittyviä tietoja tarkastellaan Kelasta tarvittaessa.',
        checkupConsent:
          'Hyväksyn, että tuloihini liittyviä tietoja tarkastellaan tarvittaessa Kelasta.',
        limitedCompanyIncomesRegister:
          'Tuloni voi tarkastaa tarvittaessa Kelasta.',
      },
    },
    sv: {},
  },
  cityLogo: <img src={MunicipalityLogo} alt="Sotkamo logo" data-qa="footer-city-logo" />,
  featureFlags,
  placementTypes: [
    'PRESCHOOL',
    'PRESCHOOL_DAYCARE',
    'DAYCARE',
    'DAYCARE_PART_TIME',
    'PREPARATORY',
    'PREPARATORY_DAYCARE',
    'CLUB',
    'TEMPORARY_DAYCARE',
    'TEMPORARY_DAYCARE_PART_DAY',
  ],
  absenceTypes: [
    'OTHER_ABSENCE',
    'SICKLEAVE',
    'UNKNOWN_ABSENCE',
    'PLANNED_ABSENCE',
    'PARENTLEAVE',
    'FORCE_MAJEURE',
  ],
  daycareAssistanceLevels: [...daycareAssistanceLevels],
  otherAssistanceMeasureTypes: [
    'TRANSPORT_BENEFIT',
    'ACCULTURATION_SUPPORT',
    'ANOMALOUS_EDUCATION_START',
  ],
  placementPlanRejectReasons: ['REASON_1', 'REASON_2', 'OTHER'],
  preschoolAssistanceLevels: [...preschoolAssistanceLevels],
  unitProviderTypes: [
    'MUNICIPAL',
    'PURCHASED',
    'PRIVATE',
    'MUNICIPAL_SCHOOL',
    'PRIVATE_SERVICE_VOUCHER',
    'EXTERNAL_PURCHASED',
  ],
  voucherValueDecisionTypes: [
    'NORMAL',
    'RELIEF_ACCEPTED',
    'RELIEF_PARTLY_ACCEPTED',
    'RELIEF_REJECTED',
  ],
  additionalStaffAttendanceTypes: [
    'OTHER_WORK',
    'TRAINING',
    'JUSTIFIED_CHANGE',
    'SICKNESS',
    'CHILD_SICKNESS',
  ],
}

export default customizations
